import React, { useState } from 'react'
import { CssBaseline } from '@mui/material'
import './index.css'
import Menu from './components/Menu'
import Home from './page/Home'
import Products from './page/Products'
import About from './page/About'
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom/cjs/react-router-dom.min'
import Footer from './components/Footer'
import { ThemeProvider } from '@emotion/react'
import theme from './theme'

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <CssBaseline />
        <Menu />
        <Switch>
          <Route exact path="/" render={() => <Home />}></Route>
          <Route path="/products" render={() => <Products />}></Route>
          <Route path="/about" render={() => <About />}></Route>
        </Switch>
        <Footer />
      </Router>
    </ThemeProvider>
  )
}
